import BaseController from '../ecat.base.controller';

export default function SettingsDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  userService,
  ecatDataService,
) {
  BaseController.call(this, userService, loaderService);
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleExpandSettingsSection = _handleExpandSettingsSection;

  vm.handleSaveSettings = _handleSaveSettings;

  _activate();

  /** ******************************************
   * Event Handlers
   */

  function _handleCloseDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.ecat.settingsDialog);
  }

  function _handleExpandSettingsSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function _handleSaveSettings() {
    const dfdSave = $q.defer();
    if ($scope.editECATSettingsForm.$valid) {
      vm.isProcessingComplete = false;
      ecatDataService.saveSettings(vm.settings).then((response) => {
        if (response.data) {
          alerts.success('The ECAT Settings have been saved successfully.');
          $rootScope.$broadcast('refreshECATSettings');
          ssDialogService.hide(ssDialogService.dialogs.ecat.editSettingsDialog);
        } else {
          alerts.error('Error occurred while saving the ECAT Settings.');
        }
        vm.isProcessingComplete = true;
        dfdSave.resolve();
      });
    } else {
      _hasValidationError();
      dfdSave.reject();
    }
  }

  /** ******************************************
   * Private Functions
   */

  function _activate() {
    vm.initPermissions().finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _hasValidationError() {
    const sections = document.querySelectorAll('.ecat-settings--expand-section');

    angular.forEach(sections, (section) => {
      const invalid = section.parentElement.parentElement.querySelector('.ng-invalid');
      if (invalid && invalid !== null) {
        angular.element(section).addClass('invalid');
      } else { angular.element(section).removeClass('invalid'); }
    });
  }
}

SettingsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'userService',
  'ecatDataService'
];
